import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות “חוסר סגירה” (ולקרוא לו בשם)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק לקרוא לזה “טירוף”. אני קורא לזה: חוסר סגירה — ומכאן מתחילים.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מפסיק לקרוא לזה “טירוף”. אני קורא לזה: חוסר סגירה — ומכאן מתחילים.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הראש שלי מחפש תשובה כדי להרגיש בטוח.”"
    ],
      [
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הראש שלי מחפש תשובה כדי להרגיש בטוח.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה — בשבילי\nאני שואל את עצמי:\nמה בדיוק נשאר פתוח אצלי? (מה חסר לי להבין/לשמוע/לראות?)",
      "אני שואל את עצמי:\nמה אני מפחד שיקרה אם לא אדע “למה”?",
      "אני שואל את עצמי:\nמה הדבר שאני עושה שוב ושוב כדי להשיג סגירה? (לשלוח/לבדוק/לשחזר/לדמיין שיחה)"
    ],
      [
      "כתיבה — בשבילי\nאני שואל את עצמי:\nמה בדיוק נשאר פתוח אצלי? (מה חסר לי להבין/לשמוע/לראות?)",
      "אני שואל את עצמי:\nמה אני מפחד שיקרה אם לא אדע “למה”?",
      "אני שואל את עצמי:\nמה הדבר שאני עושה שוב ושוב כדי להשיג סגירה? (לשלוח/לבדוק/לשחזר/לדמיין שיחה)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "חוסר סגירה הוא כאב אמיתי. היום אני מפסיק להאשים את עצמי על זה."
    ],
      [
      "סגירה",
      "חוסר סגירה הוא כאב אמיתי. היום אני מפסיק להאשים את עצמי על זה."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: נשימה אחת + משפט: “זה חוסר סגירה. אני יכול להחזיק את זה.”",
      "פעם אחת היום: נשימה אחת + משפט: “זה חוסר סגירה. אני יכול להחזיק את זה.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "סיפור מול עובדה (להפסיק להיתלות בפרטים)",
    opening: localizedGenderNode(
      [
      "היום אני מפריד בין מה שאני יודע לבין מה שהמוח מנסה להשלים.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מפריד בין מה שאני יודע לבין מה שהמוח מנסה להשלים.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “לא כל חור רוצה להיסגר היום.”"
    ],
      [
      "נשימה אחת. “לא כל חור רוצה להיסגר היום.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה העובדות היבשות שאני יודע? (2–4 שורות, בלי פרשנות)",
      "מה אני לא יודע — ואני מנסה למלא בדמיון?",
      "איזה סיפור הכאב שלי מספר על מה שאני לא יודע — ואיזו אמת עדינה אחת אני יכול לבחור היום במקום הסיפור?"
    ],
      [
      "כתיבה\nמה העובדות היבשות שאני יודע? (2–4 שורות, בלי פרשנות)",
      "מה אני לא יודע — ואני מנסה למלא בדמיון?",
      "איזה סיפור הכאב שלי מספר על מה שאני לא יודע — ואיזו אמת עדינה אחת אני יכול לבחור היום במקום הסיפור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני יכול לחיות גם עם “לא יודע” — בלי שהוא ינהל אותי."
    ],
      [
      "סגירה",
      "אני יכול לחיות גם עם “לא יודע” — בלי שהוא ינהל אותי."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “אני חוזר לעובדות.” ואז נשימה.",
      "פעם אחת היום: “אני חוזר לעובדות.” ואז נשימה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הדחף לשאול/לחפש תשובה (פרוטוקול 90 שניות)",
    opening: localizedGenderNode(
      [
      "היום אני בונה עצירה לפני כל פעולה שמבקשת סגירה בכוח.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני בונה עצירה לפני כל פעולה שמבקשת סגירה בכוח.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אני בוחר בי קודם.”"
    ],
      [
      "נשימה אחת. “אני בוחר בי קודם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזה דחף עולה לי היום? (לשלוח הודעה/לשאול חברים/לבדוק/לנתח)",
      "מה אני מנסה להרגיע דרך הדחף הזה? (חוסר ודאות/כאב/השפלה/פחד נטישה)",
      "פרוטוקול 90 שניות (קבוע מהיום):\n\n1. 3 נשימות איטיות\n\n\n2. לשים לב לגוף: איפה הדחף יושב\n\n\n3. משפט בלב: “זה דחף. הוא יעבור.”\nואז לבחור חלופה אחת קטנה.\n\n\n\nאיזו חלופה אחת אני בוחר היום במקום לחפש תשובה?"
    ],
      [
      "כתיבה\nאיזה דחף עולה לי היום? (לשלוח הודעה/לשאול חברים/לבדוק/לנתח)",
      "מה אני מנסה להרגיע דרך הדחף הזה? (חוסר ודאות/כאב/השפלה/פחד נטישה)",
      "פרוטוקול 90 שניות (קבוע מהיום):\n\n1. 3 נשימות איטיות\n\n\n2. לשים לב לגוף: איפה הדחף יושב\n\n\n3. משפט בלב: “זה דחף. הוא יעבור.”\nואז לבחור חלופה אחת קטנה.\n\n\n\nאיזו חלופה אחת אני בוחר היום במקום לחפש תשובה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה פעולה כדי להירגע. אני יכול להירגע גם בלי תשובה."
    ],
      [
      "סגירה",
      "אני לא רוצה פעולה כדי להירגע. אני יכול להירגע גם בלי תשובה."
    ]
    ),
    action: localizedGenderNode(
      "בכל פעם שעולה דחף — אני עושה את הפרוטוקול פעם אחת בלבד.",
      "בכל פעם שעולה דחף — אני עושה את הפרוטוקול פעם אחת בלבד."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מה אני באמת מחפש בתוך “סגירה”",
    opening: localizedGenderNode(
      [
      "היום אני מגלה שהסגירה שאני מחפש היא צורך עמוק יותר.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מגלה שהסגירה שאני מחפש היא צורך עמוק יותר.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אולי אני לא מחפש מידע — אני מחפש שקט.”"
    ],
      [
      "נשימה אחת. “אולי אני לא מחפש מידע — אני מחפש שקט.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאם הייתי מקבל “תשובה מושלמת” — מה הייתי מרגיש לרגע?",
      "איזה צורך מסתתר שם? (כבוד/אישור/הבנה/צדק/שייכות/ביטחון)",
      "איך אני יכול לתת לעצמי 10% מהצורך הזה בלי האדם השני?"
    ],
      [
      "כתיבה\nאם הייתי מקבל “תשובה מושלמת” — מה הייתי מרגיש לרגע?",
      "איזה צורך מסתתר שם? (כבוד/אישור/הבנה/צדק/שייכות/ביטחון)",
      "איך אני יכול לתת לעצמי 10% מהצורך הזה בלי האדם השני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "סגירה לפעמים היא לא “מה הוא אמר”. היא “מה אני נותן לעצמי”."
    ],
      [
      "סגירה",
      "סגירה לפעמים היא לא “מה הוא אמר”. היא “מה אני נותן לעצמי”."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר צורך אחד — ונותן לו גרסה קטנה היום (שיחה בטוחה/הליכה/סדר/מוזיקה).",
      "אני בוחר צורך אחד — ונותן לו גרסה קטנה היום (שיחה בטוחה/הליכה/סדר/מוזיקה)."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הכאב של “לא קיבלתי כבוד”",
    opening: localizedGenderNode(
      [
      "היום אני נוגע במקום שבו לא התייחסו אליי כמו שהייתי בוחר/ת.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני נוגע במקום שבו לא התייחסו אליי כמו שהייתי בוחר/ת.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “מותר לי לכאוב על חוסר כבוד.”"
    ],
      [
      "נשימה אחת. “מותר לי לכאוב על חוסר כבוד.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה היה חסר לי בקשר/בפרידה מבחינת כבוד?",
      "מה המשפט שאני רוצה שיישמע — ולא נשמע?",
      "איזה משפט כבוד אני יכול להגיד לעצמי היום במקום זה?"
    ],
      [
      "כתיבה\nמה היה חסר לי בקשר/בפרידה מבחינת כבוד?",
      "מה המשפט שאני רוצה שיישמע — ולא נשמע?",
      "איזה משפט כבוד אני יכול להגיד לעצמי היום במקום זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אם לא קיבלתי כבוד מבחוץ — אני מתחיל לתת אותו מבפנים."
    ],
      [
      "סגירה",
      "אם לא קיבלתי כבוד מבחוץ — אני מתחיל לתת אותו מבפנים."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב משפט כבוד אחד לעצמי ושומר אותו ביומן.",
      "אני כותב משפט כבוד אחד לעצמי ושומר אותו ביומן."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "אשמה וביקורת (“אם הייתי עושה אחרת…”)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק להצליף בעצמי בשם “הסבר”.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מפסיק להצליף בעצמי בשם “הסבר”.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “לקבל אחריות זה לא לשבור את עצמי.”"
    ],
      [
      "נשימה אחת. “לקבל אחריות זה לא לשבור את עצמי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזה “סרט אשמה” אני מריץ כדי להסביר את מה שקרה?",
      "מה חלק קטן שכן באחריות שלי — ומה לא?",
      "איך אני אומר את אותו דבר בטון רך? (בלי הזמנה להלקאה)"
    ],
      [
      "כתיבה\nאיזה “סרט אשמה” אני מריץ כדי להסביר את מה שקרה?",
      "מה חלק קטן שכן באחריות שלי — ומה לא?",
      "איך אני אומר את אותו דבר בטון רך? (בלי הזמנה להלקאה)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אחריות בלי חמלה לא סוגרת מעגל. היא פותחת פצע."
    ],
      [
      "סגירה",
      "אחריות בלי חמלה לא סוגרת מעגל. היא פותחת פצע."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה אשמה — אני חוזר למשפט הרך שלי פעם אחת בלבד.",
      "כשעולה אשמה — אני חוזר למשפט הרך שלי פעם אחת בלבד."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "“המכתב שלא נשלח” (סגירה פנימית)",
    opening: localizedGenderNode(
      [
      "היום אני נותן למוח “סיום פרק” — גם בלי שיחה אמיתית.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני נותן למוח “סיום פרק” — גם בלי שיחה אמיתית.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אני יכול לכתוב סגירה גם אם לא קיבלתי אותה.”"
    ],
      [
      "נשימה אחת. “אני יכול לכתוב סגירה גם אם לא קיבלתי אותה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמכתב שלא נשלח (6–10 שורות):\nמה אני רוצה להגיד באמת — בלי להתנצל ובלי לתקוף?",
      "איזה משפט אחד מתוך המכתב הוא הלב של הסיפור?",
      "מה אני משחרר היום מהצורך ש“הם יבינו”?"
    ],
      [
      "כתיבה\nמכתב שלא נשלח (6–10 שורות):\nמה אני רוצה להגיד באמת — בלי להתנצל ובלי לתקוף?",
      "איזה משפט אחד מתוך המכתב הוא הלב של הסיפור?",
      "מה אני משחרר היום מהצורך ש“הם יבינו”?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "סגירה לא תמיד מגיעה מבחוץ. לפעמים היא פעולה פנימית של כבוד."
    ],
      [
      "סגירה",
      "סגירה לא תמיד מגיעה מבחוץ. לפעמים היא פעולה פנימית של כבוד."
    ]
    ),
    action: localizedGenderNode(
      "אני קורא את המכתב פעם אחת — ואז סוגר אותו. לא מנתח עוד.",
      "אני קורא את המכתב פעם אחת — ואז סוגר אותו. לא מנתח עוד."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "קבלה עדינה (ACT): לחיות עם “חור פתוח” בלי להישאב",
    opening: localizedGenderNode(
      [
      "היום אני מתאמן לשאת חוסר ודאות רגע — בלי לרוץ לתשובה.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מתאמן לשאת חוסר ודאות רגע — בלי לרוץ לתשובה.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “זה אי־ודאות. והיא נסבלת.”"
    ],
      [
      "נשימה אחת. “זה אי־ודאות. והיא נסבלת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הטריגר הכי חזק שמפעיל את הצורך בסגירה?",
      "תרגול דקה אחת: אני נותן ל“לא יודע” להיות כאן דקה, בלי פעולה.\nמה קרה בגוף אחרי הדקה?",
      "מה למדתי? (האם הגל באמת לא עובר?)"
    ],
      [
      "כתיבה\nמה הטריגר הכי חזק שמפעיל את הצורך בסגירה?",
      "תרגול דקה אחת: אני נותן ל“לא יודע” להיות כאן דקה, בלי פעולה.\nמה קרה בגוף אחרי הדקה?",
      "מה למדתי? (האם הגל באמת לא עובר?)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני מתחזק לא כי קיבלתי תשובה — אלא כי נשארתי עם השאלה."
    ],
      [
      "סגירה",
      "אני מתחזק לא כי קיבלתי תשובה — אלא כי נשארתי עם השאלה."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד. עקביות > כוח.",
      "דקה אחת בלבד. עקביות > כוח."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "לשחרר פנטזיית “השיחה המושלמת”",
    opening: localizedGenderNode(
      [
      "היום אני נפרד מהסצנה שהמוח מביים כדי להירגע.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני נפרד מהסצנה שהמוח מביים כדי להירגע.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “הסצנה בראש לא מחזירה חיים.”"
    ],
      [
      "נשימה אחת. “הסצנה בראש לא מחזירה חיים.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיך נראית השיחה המושלמת בראש שלי?",
      "מה אני מחפש לקבל שם? (הכרה/התנצלות/הסבר/בחירה בי)",
      "איזה חלק קטן אני יכול לתת לעצמי היום במקום זה?"
    ],
      [
      "כתיבה\nאיך נראית השיחה המושלמת בראש שלי?",
      "מה אני מחפש לקבל שם? (הכרה/התנצלות/הסבר/בחירה בי)",
      "איזה חלק קטן אני יכול לתת לעצמי היום במקום זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני משחרר את הבמה בראש — ומחזיר את האנרגיה לחיים שלי."
    ],
      [
      "סגירה",
      "אני משחרר את הבמה בראש — ומחזיר את האנרגיה לחיים שלי."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום כשאני “מביים שיחה” — אני אומר: “לא עכשיו.” וחוזר לנשימה.",
      "פעם אחת היום כשאני “מביים שיחה” — אני אומר: “לא עכשיו.” וחוזר לנשימה."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "גבולות מול עצמי (להפסיק לפתוח את הפצע)",
    opening: localizedGenderNode(
      [
      "היום אני שם גבול אחד שמגן עליי מהאובססיה לסגירה.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני שם גבול אחד שמגן עליי מהאובססיה לסגירה.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “גבול הוא שמירה.”"
    ],
      [
      "נשימה אחת. “גבול הוא שמירה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזה פעולה הכי פותחת לי את הפצע?",
      "איזה גבול קטן אני שם לשבוע? (“השבוע אני לא _ כדי להגן עליי”)",
      "מה הפחד שלי אם אני שם את הגבול הזה — ומה תשובה רכה לפחד הזה?"
    ],
      [
      "כתיבה\nאיזה פעולה הכי פותחת לי את הפצע?",
      "איזה גבול קטן אני שם לשבוע? (“השבוע אני לא _ כדי להגן עליי”)",
      "מה הפחד שלי אם אני שם את הגבול הזה — ומה תשובה רכה לפחד הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא מעניש את עצמי. אני שומר על עצמי."
    ],
      [
      "סגירה",
      "אני לא מעניש את עצמי. אני שומר על עצמי."
    ]
    ),
    action: localizedGenderNode(
      "אני מסיר/מסתיר טריגר אחד (שיחה/תמונה/רשת) שמצית את הצורך.",
      "אני מסיר/מסתיר טריגר אחד (שיחה/תמונה/רשת) שמצית את הצורך."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "להחזיר שליטה (3 דברים שכן בידיים שלי)",
    opening: localizedGenderNode(
      [
      "היום אני מצמצם את הסערה לצעד אחד.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מצמצם את הסערה לצעד אחד.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “צעד אחד מספיק.”"
    ],
      [
      "נשימה אחת. “צעד אחד מספיק.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הכי מציף אותי היום סביב חוסר הסגירה?",
      "מה 3 דברים שכן בשליטתי היום? (קטנים מאוד)",
      "איזה צעד אחד בלבד אני עושה היום?"
    ],
      [
      "כתיבה\nמה הכי מציף אותי היום סביב חוסר הסגירה?",
      "מה 3 דברים שכן בשליטתי היום? (קטנים מאוד)",
      "איזה צעד אחד בלבד אני עושה היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה"
    ],
      [
      "סגירה"
    ]
    ),
    action: localizedGenderNode(
      "פעולה קטנה להיום",
      "פעולה קטנה להיום"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "הלילה והלופים (משפט סגירה ללילה)",
    opening: localizedGenderNode(
      [
      "היום אני נותן למוח “סוף יום” כדי לנוח.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני נותן למוח “סוף יום” כדי לנוח.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “הלילה אני לא רוצה לפתור.”"
    ],
      [
      "נשימה אחת. “הלילה אני לא רוצה לפתור.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הלופ הלילי הקבוע שלי?",
      "מה הלופ מנסה להשיג בשבילי? (שליטה/הבנה/תקווה)",
      "איזה משפט סגירה ללילה אני בוחר — ואיזה טקס של 3 דקות יעזור לי לפני שינה?"
    ],
      [
      "כתיבה\nמה הלופ הלילי הקבוע שלי?",
      "מה הלופ מנסה להשיג בשבילי? (שליטה/הבנה/תקווה)",
      "איזה משפט סגירה ללילה אני בוחר — ואיזה טקס של 3 דקות יעזור לי לפני שינה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מוח עייף מספר סיפורים חזקים. הלילה אני בוחר מנוחה."
    ],
      [
      "סגירה",
      "מוח עייף מספר סיפורים חזקים. הלילה אני בוחר מנוחה."
    ]
    ),
    action: localizedGenderNode(
      "לפני שינה: משפט הסגירה שלי + נשימה אחת. זה הכול.",
      "לפני שינה: משפט הסגירה שלי + נשימה אחת. זה הכול."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "להפוך חוסר סגירה לכיוון (מה אני בונה עכשיו)",
    opening: localizedGenderNode(
      [
      "היום ה“פתוח” הופך למצפן: מה אני רוצה לעשות אחרת מעכשיו.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום ה“פתוח” הופך למצפן: מה אני רוצה לעשות אחרת מעכשיו.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אם זה כאב לי — זה מלמד אותי.”"
    ],
      [
      "נשימה אחת. “אם זה כאב לי — זה מלמד אותי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה אני לומד על מה שאני בוחר/ת בקשר הבא/בחיים שלי?",
      "איזה ערך אחד יוביל אותי מעכשיו? (כבוד/אמת/שקט/יציבות)",
      "איזה הרגל קטן מקרב אותי לערך הזה השבוע — ומה אני מבטיח לעצמי כשיעלה דחף “לסגור בכוח”?"
    ],
      [
      "כתיבה\nמה אני לומד על מה שאני בוחר/ת בקשר הבא/בחיים שלי?",
      "איזה ערך אחד יוביל אותי מעכשיו? (כבוד/אמת/שקט/יציבות)",
      "איזה הרגל קטן מקרב אותי לערך הזה השבוע — ומה אני מבטיח לעצמי כשיעלה דחף “לסגור בכוח”?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה להיתקע על העבר כדי לבנות עתיד."
    ],
      [
      "סגירה",
      "אני לא רוצה להיתקע על העבר כדי לבנות עתיד."
    ]
    ),
    action: localizedGenderNode(
      "אני מתכנן דבר אחד קטן לשבוע הקרוב שמחזיר לי עתיד (פגישה/שגרה/פרויקט).",
      "אני מתכנן דבר אחד קטן לשבוע הקרוב שמחזיר לי עתיד (פגישה/שגרה/פרויקט)."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "טקס שחרור וסגירה (סגירה רכה)",
    opening: localizedGenderNode(
      [
      "היום אני סוגר פרק בלי למחוק אותו. אני נשאר עם עצמי.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני סוגר פרק בלי למחוק אותו. אני נשאר עם עצמי.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אני משחרר בלי להיעלם.”"
    ],
      [
      "נשימה אחת. “אני משחרר בלי להיעלם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nשלושה דברים שאני מפסיק לעשות כדי להגן על הלב שלי:",
      "שלושה דברים שאני מתחיל לעשות כדי לבנות אותי:",
      "משפט חזרה לימים קשים (קצר, ברור, בכיס):"
    ],
      [
      "כתיבה\nשלושה דברים שאני מפסיק לעשות כדי להגן על הלב שלי:",
      "שלושה דברים שאני מתחיל לעשות כדי לבנות אותי:",
      "משפט חזרה לימים קשים (קצר, ברור, בכיס):"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני אולי לא אקבל את התשובה שרציתי.",
      "אבל אני כן יכול לקבל את החיים שלי בחזרה.",
      "אני ממשיך ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני אולי לא אקבל את התשובה שרציתי.",
      "אבל אני כן יכול לקבל את החיים שלי בחזרה.",
      "אני ממשיך ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר פעולה אחת שמסמלת “פרק חדש”: ניקוי קטן בבית / הליכה במקום חדש / סידור יומן שבועי.",
      "אני בוחר פעולה אחת שמסמלת “פרק חדש”: ניקוי קטן בבית / הליכה במקום חדש / סידור יומן שבועי."
    ),
  },
].map(buildNormalizedDay);

export const lackOfClosureAfterBreakupBlueprintHe = buildNormalizedPilotBlueprint({
  id: "lack_of_closure_after_breakup_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "lack_of_closure_after_breakup",
  category: "general",
  journeyName: {
    he: "חוסר סגירה ופרידה לא פתורה",
    en: "Lack of Closure & Unresolved Separation",
    es: "Falta de cierre y separación no resuelta",
  },
  days,
});

export default lackOfClosureAfterBreakupBlueprintHe;
